import * as Yup from "yup";
import type { Moment } from "moment-timezone";
import moment from "moment-timezone";

export const getScheduleExceptionsValidationSchema = (t) => () => {
    // When breaking out Yup schemas into separate file, do put them in factory functions
    // to make sure validation localizations are loaded before schema is created

    return Yup.object().shape({
        isOnType: Yup.boolean().required(),
        durationSeconds: Yup.number().when("showAdvancedMode", {
            is: true,
            then: Yup.number().optional(),
            otherwise: Yup.number().required().positive(),
        }),
        dtStart: Yup.object<Moment>().when("showAdvancedMode", {
            is: true,
            then: Yup.object<Moment>()
                .required()
                .test({
                    name: "isFutureMoment",
                    message: t("Validation.irDateFuture"),
                    test: (dateTime: Moment) =>
                        moment.isMoment(dateTime) && dateTime.isAfter(moment().subtract(5, "minutes")),
                }),
            otherwise: Yup.object<Moment>().optional().nullable(),
        }),
        dtStop: Yup.object<Moment>().when("showAdvancedMode", {
            is: true,
            then: Yup.object<Moment>()
                .required()
                .test({
                    name: "isFutureMoment",
                    message: t("Validation.irDateFuture"),
                    test: (dateTime: Moment) =>
                        moment.isMoment(dateTime) && dateTime.isAfter(moment().subtract(5, "minutes")),
                })
                .test({
                    name: "isAfterOtherMoment",
                    message: t("Validation.DateTimeGreaterThan"),
                    test(dtStop: Moment) {
                        // Don't use arrow function since "this" is needed
                        // eslint-disable-next-line react/no-this-in-sfc
                        const dtStart = this.resolve(Yup.ref("dtStart")) as Moment;
                        return moment.isMoment(dtStop) && dtStop.isAfter(dtStart);
                    },
                }),
            otherwise: Yup.object<Moment>().optional().nullable(),
        }),
        showAdvancedMode: Yup.boolean(),
    });
};
